import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import AppConstatnts from "../../../common/AppConstants";
import AppDataContext from "../../../common/appContext";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";
import {
  getDropDown,
  getInputBox,
} from "../../../sharedComponents/formFields/LabelInFormFields";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";

const CollegeExperienceViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  setAlert,
  setAlertType,
  setAlertMessage,
  viewProfile,
  //   user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    eventId: eventId,
    classTypeId: null,
    classTypeName: "",
    collegeName: "",
    conferenceId: null,
    conferenceName: "",
    contact: "",
    email: "",
    id: 0,
    mode: null,
    phone: "",
    playerID: playerID,
    userBy: user?.loginID,
    years: "",
  };
  const defaultErrors = {
    email: false,
    years: false,
  };
  const defaultErrorMsg = {
    email: "",
    years: "",
  };
  const [collegeGridData, setCollegeGridData] = useState([]);
  const [collegeFormData, setCollegeFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [dropDownData, setDropDownData] = useState({
    classList: [],
    conferenceList: [],
  });
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );

  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "classTypeName",
      headerName: "College Class",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "years",
      headerName: "College Year",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "collegeName",
      headerName: "College",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "conferenceName",
      headerName: "College Conference",
      width: 180,
      flex: columnFlex,
    },
    {
      field: "contact",
      headerName: "College Contact",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "phone",
      headerName: "College Contact Phone",
      width: 190,
      flex: columnFlex,
    },
    {
      field: "email",
      headerName: "College Contact Email",
      width: 190,
      flex: columnFlex,
    },
  ];

  useEffect(() => {
    fetchDropDownDataforCollegeDetails();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    setCollegeGridData(gridPropsData);
    setCollegeFormData(formData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return collegeFormData.classTypeId ||
      collegeFormData.years ||
      collegeFormData.collegeName ||
      collegeFormData.conferenceId ||
      collegeFormData.contact ||
      collegeFormData.email ||
      collegeFormData.phone
      ? false
      : true;
  };

  //---HANDLERS---

  //single handler to open and close delete confirmation dialog box
  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the clg details to edit from grid data
  //2. set the input boxes with college details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = collegeGridData.find((c, i) => {
      return c.id === id;
    });
    setCollegeFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setCollegeFormData(formData);
  };

  //common input change handler from TEXTBOX input
  const handleInputChange = (e, key) => {
    let value = e.target.value;
    switch (key) {
      case "years":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.YEAR_REGEX)
        )
          toggleError(key, true, "Invalid Year");
        else toggleError(key, false, "");
        break;
      case "email":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.EMAIL_REGEX)
        )
          toggleError(key, true, "Invalid Email");
        else toggleError(key, false, "");
        break;
    }
    setCollegeFormData({
      ...collegeFormData,
      [key]: value || "",
    });
  };

  //common input change handler for DROPDOWN input
  const handleDropdownInputChange = (e, keyId, keyName, dropdownList) => {
    let result = dropdownList.find((d, i) => {
      return d.childID === e.target.value;
    });
    setCollegeFormData({
      ...collegeFormData,
      [keyId]: result.childID || null,
      [keyName]: result.childID ? result.childName : "",
    });
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveClick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(collegeFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = collegeGridData.find((c, i) => {
      return c.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(true, "success", "College record deleted Successfully.");
      }
    }
  };

  //---APIs---

  const fetchDropDownDataforCollegeDetails = async () => {
    try {
      const [classListResponse, conferenceListResponse] = await Promise.all([
        PlayerProfileService.getCollegeClassList(),
        PlayerProfileService.getCollegeConferenceList(),
      ]);
      setDropDownData({
        ...dropDownData,
        classList: [
          { childID: "", childName: "None" },
          ...classListResponse.data,
        ],
        conferenceList: [
          { childID: "", childName: "None" },
          ...conferenceListResponse.data,
        ],
      });
    } catch (error) {
      console.error("Error in fetchDropDownDataforCollegeDetails :", error);
    }
  };

  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result = await PlayerProfileService.insertUpdateCollegeDetails(
        formData
      );
      if (result) {
        getUpdatedCollegeGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedCollegeGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setCollegeGridData(result.data.college);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              College Experience
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="Cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveClick}
                >
                  <TitleTooltip title="Save college details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            <Grid item lg={1.5} md={6} sm={12} xs={12}>
              {getDropDown(
                "College Class",
                collegeFormData.classTypeId,
                (e) =>
                  handleDropdownInputChange(
                    e,
                    "classTypeId",
                    "classTypeName",
                    dropDownData.classList
                  ),
                dropDownData.classList
              )}
            </Grid>
            <Grid item lg={1.5} md={6} sm={12} xs={12}>
              {getInputBox(
                "College Year",
                collegeFormData.years,
                (e) => handleInputChange(e, "years"),
                false,
                "text",
                error.years
                // errorMessage.years
              )}
            </Grid>
            <Grid item lg={1.5} md={6} sm={12} xs={12}>
              {getInputBox("College", collegeFormData.collegeName, (e) =>
                handleInputChange(e, "collegeName")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getDropDown(
                "College Conference",
                collegeFormData.conferenceId,
                (e) => {
                  handleDropdownInputChange(
                    e,
                    "conferenceId",
                    "conferenceName",
                    dropDownData.conferenceList
                  );
                },
                dropDownData.conferenceList
              )}
            </Grid>
            <Grid item lg={1.8} md={6} sm={12} xs={12}>
              {getInputBox("College Contact", collegeFormData.contact, (e) => {
                handleInputChange(e, "contact");
              })}
            </Grid>
            <Grid item lg={1.8} md={6} sm={12} xs={12}>
              {getInputBox(
                "College Contact Phone",
                collegeFormData.phone,
                (e) => handleInputChange(e, "phone")
              )}
            </Grid>
            <Grid item lg={1.9} md={6} sm={12} xs={12}>
              {getInputBox(
                "College Contact Email",
                collegeFormData.email,
                (e) => handleInputChange(e, "email"),
                false,
                "text",
                error.email
                // errorMessage.email
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={collegeGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => handleOpenCloseConfirmationBox(false)}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};

export default React.memo(CollegeExperienceViewUpdate);
